function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@font-face{font-family:&quot;Virgil&quot;;src:url(https://excalidraw.com/FG_Virgil.woff2)}@font-face{font-family:&quot;Cascadia&quot;;src:url(https://excalidraw.com/Cascadia.woff2)}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e64980",
  strokeWidth: 0,
  d: "M37.014 26.498l143.985-.426 24.377 2.57 6.944 9.578 1.227 9.18.551 63.988-4.317 22.823-5.16 3.21-20.314 7.154-147.41-4.726-12.832-1.556-9.125-7.33-1.131-11.203-7.275-72.967L10.58 36.71l13.299-7.038 16.69-5.982"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M40.983 29.884c53.37-2.077 103.023.709 139.404-6.427M37.973 26.769c50.504 1.054 95.097-1.005 144.048 1.217m1.729-1.486c15.682 3.263 33.249 11.505 32.445 27.648m-29.955-30.87c13.401-.972 27.962 15.746 26.44 36.007m1.581-4.334c.453 22.667-3.216 44.28-1.884 62.132m.917-59.646c-1 19.277.4 41.155 1.495 57.352M213 114.25c-3.22 22.763-13.536 30.093-31.805 26.318m29.28-28.363c3.819 22.611-4.544 26.728-28.723 29.952m4.86.281c-44.925 4.335-95.785 6.864-150.528 4.568m146.824-3.977c-51.926-1.582-101.706-1.197-141.814-.956M39.25 143.5c-19.355-3.484-27.495-6.256-29.707-29.959m33.192 28.072c-19.27 2.63-35.517-4.945-37.144-24.374m7.085-1.145C5.9 101.388 9.158 87.199 10.558 57.07m-1.54 56.952c2.51-18.176-.242-34.048 1.167-60.003M10 55.75C6.838 38.57 22.963 27.974 38.271 23.397m-26.13 34.84c2.305-23.5 7.048-29.92 23.76-29.347"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#e64980",
  strokeWidth: 0,
  d: "M430.322 32.802l142.957-.369 20.09 1.685 5.523 7.406 2.29 10.765 5.455 67.508-8.217 15.334-4.27 4.403-22.551 9.106-141.942-1.813-17.842-1.589-7.547-14.586-4.412-10.58.884-66.225 3.93-12.104 5.445-10.062 22.119.123"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M431.047 26.798000000000002c52.395-2.334 95.878 2.14 147.686 2.104m-146.73-.804c32.066-3.524 68.485-.197 142.446-1.007M575.25 29c21.255 2.49 26.027 9.472 32.513 33.249m-29.439-36.387c19.2 5.735 24.18 15.428 21.982 33.59m5.21-2.649c.527 20.218 1.583 42.892-3.386 60.262m1.9-57.428c1.432 18.813 1.995 34.157-.996 55.503m1.466 1.61c.843 16.975-11.795 27.513-25.987 25.464m24.82-24.34c-3.4 19.24-9.282 31.258-27.017 30.807m.24-3.48c-51.16.522-105.178 6.04-144.657.222m141.715 1.722c-36.882-.633-74.325-2.706-143.218-1.073m.354-.072c-16.006 3.485-31.137-13.584-32.734-27.495m35.333 30.726c-19.181-4.993-29.24-17.161-31.105-35.263m1.704 2.604c.58-20.728-1.668-42.532-3.034-55.61m.05 54.392c2.129-13.095-1.061-28.444-1.015-58.685m1.551 1.581c1.474-17.359 12.236-32.162 31.57-26.037M403.58 62.116c-.262-19.733 3.074-32.065 25.658-33.677M218.667 64.156c29.796-.962 149.186-5.973 179.036-7.36M216.527 61.8c29.246-.45 149.345-1.286 179.32-1.942"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M368.091 71.5c9.396-4.59 19.11-8.996 29.893-8.595m-31.364 5.766c9.503-1.541 15.633-4.218 30.903-9.486"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2,
  d: "M367.815 50.981c9.303 3.511 19.127 7.21 30.169 11.924m-31.64-14.754c9.63 3.605 15.829 6.075 31.179 11.034"
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeDasharray: "12 8",
  strokeWidth: 2.5,
  d: "M213.721 120.84c28.19-.563 144.24-2.751 173.784-3.829"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeWidth: 2.5,
  d: "M358.231 126.593c12.971.966 20.327-4.623 29.732-9.266M357.689 106.079c12.98 9.148 20.553 11.735 30.274 11.248"
}));

function SvgTraditionalDependency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 614.5 185"
  }, props), _ref, _ref2, _ref3, /*#__PURE__*/React.createElement("text", {
    y: 19,
    fill: "#fff",
    fontFamily: "Cascadia, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(39 71)",
    style: {
      whiteSpace: "pre"
    }
  }, "SignupService"), _ref4, _ref5, _ref6, _ref7, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 23,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(269 10)",
    style: {
      whiteSpace: "pre"
    }
  }, "Import")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 23,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(259 143)",
    style: {
      whiteSpace: "pre"
    }
  }, "Execute")), _ref8, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    y: 19,
    fill: "#fff",
    fontFamily: "Cascadia, Segoe UI Emoji",
    fontSize: 20,
    transform: "translate(451.5 76.25)",
    style: {
      whiteSpace: "pre"
    }
  }, "HttpClient")));
}

export default __webpack_public_path__ + "static/traditional-dependency.4265ed49.svg";
export { SvgTraditionalDependency as ReactComponent };